import apiService from "./apiService";
import AppConstants from "../appConstants";

class AskAnalystService {
    getAllAskAnalyst(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_ASK_ANALYST, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getAllAskAnalystByUser(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_ASK_ANALYST_BY_USER, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_ASK_ANALYST_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    answerQuestion(params, body) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_ASK_ANALYST_NEW_ANSWER, body, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    // =====================================================================
}

export default new AskAnalystService();
